module.exports = __webpack_public_path__ + "static/media/ico-use-active.f41ab243.svg";